const $signIn = $('#sign-in-mobile');
const $resetPassword = $('#reset-password-mobile');
const $signInEmail = $signIn.find('[type=email]');
const $resetPasswordEmail = $resetPassword.find('[type=email]');
const $backToLoginFormButton = $('#back-button');
const $forgotEmailMessage = $('#forgot-email-message');

function show($element) {
  $element
    .removeClass('fadeOutDown')
    .removeClass('hidden')
    .addClass('fadeInUp');
}

function hide($element) {
  if (!$element.hasClass('hidden')) {
    $element
      .removeClass('fadeInUp')
      .addClass('fadeOutDown')
      .addClass('hidden');
  }
}

if ($signIn.length) {
  $signInEmail.on('change', function() {
    $resetPasswordEmail.val(this.value);
  });

  $('[data-change]').on('click touchstart', function(event) {
    const change = this.dataset.change;
    switch (change) {
      case '#sign-in-mobile':
        hide($resetPassword)
        hide($forgotEmailMessage)
        hide($backToLoginFormButton)
        show($signIn)
        break;
      case '#reset-password-mobile':
        hide($signIn)
        show($backToLoginFormButton)
        show($resetPassword)
        break;
      case '#forgot-email-message':
        hide($signIn)
        show($backToLoginFormButton)
        show($forgotEmailMessage)
    }
  });
}
